<div class="p-4 md:p-8" style="max-width: 520px; margin: 0 auto;">

  <!-- Progress bar -->
  <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 16px 20px; margin-bottom: 20px;">
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
      <button type="button" (click)="previousStep()"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #374151;">arrow_back</mat-icon>
        Atrás
      </button>
      <span style="background: #1C593D; color: white; padding: 4px 14px; border-radius: 20px; font-size: 0.8rem; font-weight: 700;">
        Paso {{ currentStep }}/{{ totalSteps }}
      </span>
    </div>
    <div style="width: 100%; height: 8px; background: #dcfce7; border-radius: 20px; overflow: hidden;">
      <div style="height: 100%; background: #1C593D; border-radius: 20px; transition: width 0.3s ease;"
        [style.width.%]="(currentStep / totalSteps) * 100"></div>
    </div>
  </div>

  <!-- Horario -->
  <div style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; margin-bottom: 20px; justify-content: center;">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">schedule</mat-icon>
    <span style="font-size: 0.78rem; font-weight: 600; color: #1e5a3f;">Horario de operacion: 4:00 - 23:00</span>
  </div>

  <!-- Step 1: Beneficiario -->
  <div *ngIf="currentStep === 1" class="step-slide"
    [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <app-beneficiary-zelle
      #beneficiarioComponent
      (changeStep)="nextStep($event)"
      (beneficiarioOutput)="assignBeneficiario($event)"
      (goBack)="previousStep()">
    </app-beneficiary-zelle>
  </div>

  <!-- Step 2: Calculadora -->
  <div *ngIf="currentStep === 2" class="step-slide"
    [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <app-calculator-zelle-cal
      #calculatorComponent
      (clpCurrencyEmit)="assignClp($event)"
      (zelleCurrencyEmit)="assignZelle($event)"
      (changeStep)="nextStep($event)"
      (goBack)="previousStep()"
      [zelle_buy_rate]="zelleSellValue"
      [zelle_sell_rate]="zelleBuyValue"
      [saldoActual]="saldoActual"
      [sobregiroDisponible]="sobregiroDisponible"
      [saldoContable]="saldoContable"
      [lineaCreditoBloqueada]="lineaCreditoBloqueada"
      [lineaCredito]="lineaCredito"
      [limitSell]="limitSellZelle">
    </app-calculator-zelle-cal>
  </div>

  <!-- Step 3: Resumen -->
  <div *ngIf="currentStep === 3" class="step-slide"
    [class.slide-in-left]="slideDirection === 'left'" [class.slide-in-right]="slideDirection === 'right'">
    <app-summary-order-zelle
      [clpCurrency]="clpCurrency"
      [zelleCurrency]="zelleCurrency"
      [usdt_clp_tax_zelle]="zelleSellValue"
      [beneficiario]="beneficiario"
      [valorCambioId]="valorCambioId"
      [verificarOperacion]="operacionSigueAbierta"
      (goBack)="previousStep()">
    </app-summary-order-zelle>
  </div>

</div>
